<template>
  <div class="network-error">
    <div class="network-error__content">
      <ion-icon :icon="cloudOfflineOutline" class="network-error__icon" />
      <h2 class="network-error__title">{{ $t('networkError.title') }}</h2>
      <p class="network-error__message">{{ $t('networkError.message') }}</p>
      <base-button
        expand="block"
        @click="$emit('retry')"
      >
        {{ $t('networkError.retry') }}
      </base-button>
    </div>
  </div>
</template>

<script setup>
import { IonIcon } from '@ionic/vue';
import { cloudOfflineOutline } from 'ionicons/icons';
import BaseButton from '@/components/Base/BaseButton.vue';

defineEmits(['retry']);
</script>

<style scoped>
.network-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: #fff;
  padding: 0 32px;
}

.network-error__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
}

.network-error__icon {
  font-size: 64px;
  color: var(--ion-color-medium);
  margin-bottom: 16px;
}

.network-error__title {
  font-size: 20px;
  font-weight: 600;
  color: var(--ion-text-color);
  margin: 0 0 8px;
}

.network-error__message {
  font-size: 14px;
  color: var(--ion-color-medium);
  margin: 0 0 32px;
  line-height: 1.5;
}
</style>
